import { ApiClientService, EntityApiService } from '@dofleini/security';

import { authentication } from '@/settings';

class ProtectedAreaApiService extends EntityApiService {
  
  count = (params) => {
    return ApiClientService.post(this.getPath('/count'), params);
  }
  
}

export default new ProtectedAreaApiService(`${authentication.path}/api/protected-areas`);
